import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {PurchaseOrderModel} from '../../../api/entity/purchaseOrder.model';

@Injectable({providedIn: 'root'})
export class PurchaseOrderRepository extends AbstractRepositoryV2<PurchaseOrderModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PurchaseOrder', serviceElementsFactory, injector);
    }
}
